module.exports = __webpack_public_path__ + "static/img/7.cccc4a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/7.png
// module id = qnU3
// module chunks = 0